import { type NotificationProps } from '@capsicum/common';
import { type FC } from 'react';

import { Snackbar } from '../snackbar/Snackbar';

/**
 * @deprecated Use `Snackbar` component instead.
 */
export const Notification: FC<NotificationProps> = ({ message, notificationId, testID, title, variant }) => {
	return (
		<Snackbar
			description={message}
			notificationId={notificationId}
			testID={testID}
			title={title}
			variant={variant}
		/>
	);
};
